import { Card, pn } from "@compass/core";
import { DevExpressReport, renderReportColumn } from "components";
import { ReportPropertyBase, StudentReportEventTrackingResponse } from "generated/openApi";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

export const EventTrackingResponse = (props: {
  response: StudentReportEventTrackingResponse;
}) => {
  const appTenantName = useSelector((state: RootState) => state.app.tenantName);

  const onExporting = () => {
    let infoTuples: [string, string | undefined][] = [];

    props.response.filterDisplays?.forEach((filterDisplay) => {
      infoTuples.push([
        `${filterDisplay.label!}${filterDisplay.operator ? ` (${filterDisplay.operator})` : ""}`,
        filterDisplay.values?.join(", "),
      ]);
    });

    return {
      header: "Event Tracking Report",
      filename: "EventTrackingReport",
      tenantName: appTenantName,
      infoTuples: infoTuples,
    };
  };

  return (
    <Card header="Event Tracking Report">
      <DevExpressReport
        dataSource={props.response.rows}
        //fullPageSize
        exportFormats={["pdf", "excel", "csv"]}
        onExporting={onExporting}
      >
        {props.response.properties?.map((property) =>
          renderReportColumn({
            property: property,
            propertyKey: pn<ReportPropertyBase>("propertyName"),
          })
        )}
      </DevExpressReport>
    </Card>
  );
};
